<template>
  <div class="subjectColumnBox">
    <h1 class="study-title">
      <img
        src="../../../assets/img/personalImg/subjectIcon.png"
        alt=""
      /><span>各学科课程学习时长</span>
    </h1>
    <div id="subjectColumnchart"></div>
  </div>
</template>
<script>
import { Column } from '@antv/g2plot';

export default {
  props: {
    subjectList: {
      type: Array,
      default: () => { },
    },
  },
  methods: {
    // Y轴最大值比最大数据大20
    getMaxY() {
      // eslint-disable-next-line no-confusing-arrow
      const maxValue = this.subjectList.reduce((prev, cur) => prev.dayLearnDuration > cur.dayLearnDuration ? prev : cur);
      if (maxValue.dayLearnDuration > 10000) {
        return maxValue.dayLearnDuration + 50000;
      }
      return maxValue.dayLearnDuration + 25;
    },
  },
  mounted() {
    const data = this.subjectList;
    const subjectColumPolt = new Column('subjectColumnchart', {
      data,
      height: 222,
      tooltip: false, // 不显示柱形图的提示数据
      xField: 'name',
      yField: 'dayLearnDuration',
      columnStyle: {
        radius: [14, 14, 14, 14],
        fill: 'l(90) 0:#FF7634 1:#FFA376', // 柱形颜色
      },
      label: {
        // 柱形图上的数字
        content: (originData) => {
          const val = originData.dayLearnDuration === 0 ? '' : `${originData.dayLearnDuration}h`;
          return val;
        },
        style: {
          fill: '#666',
          fontSize: 14,
          fontWeight: 400,
          opacity: 0.6,
        },
      },
      maxColumnWidth: 14,
      yAxis: {
        // 去掉背景横杠
        grid: null,
        max: this.getMaxY(),
        label: {
          style: {
            fontSize: 12,
          },
        },
      },
      xAxis: {
        // 增加竖着的虚线
        grid: {
          line: {
            style: {
              stroke: '#E8E8E8',
              lineWidth: 2,
              lineDash: [4, 5],
              strokeOpacity: 0.7,
            },
          },
        },
        tickLine: null,
        line: {
          style: {
            stroke: '#fff',
          },
        },
      },
    });

    subjectColumPolt.render();
  },
};
</script>
<style scoped lang="scss">
.subjectColumnBox {
  width: 678px;
  margin: 0 auto;
  padding: 36px 33px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.02);
  .study-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 36px;
    img {
      width: 29px;
      height: 29px;
    }
    span {
      padding-left: 5px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }
  }
}
</style>
